import React from 'react';
import { motion } from 'framer-motion';
import { CalendarIcon } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-32 px-6 bg-carbon-light border-t border-carbon-lighter relative overflow-hidden" data-id="element-16">
      {/* Radial gradient background accent */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(242,183,5,0.05)_0%,transparent_70%)] pointer-events-none" data-id="element-17" />

      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="max-w-3xl mx-auto text-center relative z-10" data-id="element-18">
        <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-extrabold text-white leading-tight mb-10 text-balance" data-id="element-19">
          Deja de depender de la temporada. <br data-id="element-20" />
          <span className="text-gold" data-id="element-21">Empieza a cobrar todos los meses.</span>
        </h2>

        <a href="https://calendar.app.google/PYPdcRoYne7QrNJA7" target="_blank" rel="noopener noreferrer" className="group relative inline-flex items-center justify-center gap-3 bg-gold hover:bg-gold-dark text-carbon font-heading font-bold text-lg md:text-2xl px-10 py-6 rounded-xl transition-all duration-300 animate-cta-glow hover:scale-105 active:scale-95 w-full md:w-auto shadow-2xl" data-id="element-22">
          <CalendarIcon className="w-7 h-7" data-id="element-23" />
          <span data-id="element-24">QUIERO CONTRATOS RECURRENTES AHORA</span>
        </a>
      </motion.div>
    </section>;
}